import Checkbox from "components/checkbox";
import PropTypes from "prop-types";
import intl from "react-intl-universal";
import styled from "styled-components";
import { LABEL_WIDTH } from "./constants";

const StyledTableLabel = styled.div`
  background-color: var(--color-neutral-background) !important;
  display: flex;
  box-sizing: border-box;
  min-height:56px;

  .etb-label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 5px;
    font-size: 14px;
    font-weight: bold;
    color: var(--color-contrast-white);
    min-width: ${LABEL_WIDTH}px;
    background-color: var(--color-brand-300);
    border-right: 1px solid var(--color-contrast-white);
  }

  .etb-values {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    align-items: stretch;

    .etb-column {
      color: var(--color-contrast-white);
      border-right: 1px solid var(--color-contrast-white);
      border-bottom: 1px solid #dbdbdb;
      background-color: var(--color-brand-300);

      &:last-child {
        border-right: none;
      }
    }
  }

  .etb-column-optimization {
    text-transform: uppercase;


  }

  .components {
    min-width: 40px;
    max-width: 40px;
    flex-shrink: 0;
  }

  .check-style{
    margin-left: 6px;
  }
`;

const LABEL_NAMES = {
  Tipo: "Tipo",
  CodPortal: "Cód.Portal",
  CodSAP: "Cód.SAP",
  Load: "Load",
  Origem: "Origem",
  Destino: "Destino",
  Coleta: "Coleta",
  Entrega: "Data entrega",
  Material: "Material",
  Quantidade: "Quantidade",
  Pendente: "Pendente",
  QuantityConverted: "QuantityConverted",
  UnitOfMeasure: "UnitOfMeasure",
  Cancelado: "Cancelado",
  Situacao: "Situação",
  Atualizacao: "Atualização",
  Prioridade: "Prioridade",
};

export const labelName = (name) => {
  let title = "";

  switch (name) {
    case LABEL_NAMES.Tipo:
      title = intl.get("master-data.general-configuration.type");
      break;
    case LABEL_NAMES.CodPortal:
      title = intl.get("commons.codPortal");
      break;
    case LABEL_NAMES.CodSAP:
      title = intl.get("commons.po");
      break;
    case LABEL_NAMES.Load:
      title = intl.get("transports.otimizationCharge.columns.loadCode");
      break;
    case LABEL_NAMES.Origem:
      title = intl.get("commons.source");
      break;
    case LABEL_NAMES.Destino:
      title = intl.get("commons.destiny");
      break;
    case LABEL_NAMES.Coleta:
      title = intl.get("commons.pickupDate");
      break;
    case LABEL_NAMES.Entrega:
      title = intl.get("commons.deliveryDate");
      break;
    case LABEL_NAMES.Material:
      title = intl.get("commons.material");
      break;
    case LABEL_NAMES.Quantidade:
      title = intl.get("commons.amount");
      break;
    case LABEL_NAMES.Pendente:
      title = intl.get("transports.otimizationCharge.columns.pendingQty");
      break;
    case LABEL_NAMES.QuantityConverted:
      title = intl.get("transports.otimizationCharge.columns.quantityConverted");
      break;
    case LABEL_NAMES.UnitOfMeasure:
      title = intl.get("transports.otimizationCharge.columns.unitOfMeasure");
      break;
    case LABEL_NAMES.Cancelado:
      title = intl.get("commons.cancelled");
      break;
    case LABEL_NAMES.Situacao:
      title = intl.get("commons.status");
      break;
    case LABEL_NAMES.Atualizacao:
      title = intl.get("transports.otimizationCharge.columns.lastUpdateDate");
      break;
    case LABEL_NAMES.Prioridade:
      title = intl.get("commons.Priority");
      break;
  }
  return title;
};

const TableLabel = ({ labelsList, columnTemplate, allChecked, onSelectAllItens, showCheckbox }) => (
  <StyledTableLabel className="etb-row-labels">
    <div
      className="etb-values"
      style={
        columnTemplate
          ? { display: "grid", gridTemplateColumns: `40px ${columnTemplate}` }
          : undefined
      }
    >
      <div key={-1} className="etb-column-optimization components">
        {showCheckbox() && (
          <div className="check-style">
            <Checkbox
              name="allCheckedOptimization"
              checked={allChecked}
              onChange={() => onSelectAllItens(!allChecked)}
            />
          </div>
        )}
      </div>
      {labelsList.map((label) => (
        <div
          key={label.name}
          className="etb-column-optimization-label"
          style={label.customLabelStyle}
        >
          {labelName(label.name)}
        </div>
      ))}
    </div>
  </StyledTableLabel>
);

TableLabel.propTypes = {
  labelsList: PropTypes.array,
  columnTemplate: PropTypes.string,
  allChecked: PropTypes.bool.isRequired,
  onSelectAllItens: PropTypes.func.isRequired,
  showCheckbox: PropTypes.func.isRequired,
};

export default TableLabel;
